import PropTypes from 'prop-types';

import './index.less';

function NavigationMenu({
  children,
  title,
}) {
  return (
    <div className="navigation-menu">
      <div className="navigation-menu__title">
        {title}
      </div>
      <div className="navigation-menu__menu">
        {children}
      </div>
    </div>
  );
}

NavigationMenu.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
};

export default NavigationMenu;
